import React, { useContext } from "react";
import { Button } from "@cmsgov/ds-medicare-gov";
import { useTranslate, sendTealiumEvent } from "../../helpers";
import { DrugAutocomplete } from "../../components";
import { AppContext } from "../../app/store";
import { sendDrugConfirmationTealiumEvent } from "../../helpers/prescriptionHelpers";
import { AutocompleteDrug, AutocompletePapDrug } from "../../@types";

interface AddPrescriptionProps {
  onSelectDrug: (addedDrug: {
    is_generic: boolean;
    rxcui: string;
    name: string;
  }) => void;
  goToPlans: () => void;
  goToPharmacySelection: () => void;
  goToViewPrescriptions: () => void;
}

const AddPrescription: React.FunctionComponent<AddPrescriptionProps> = props => {
  const t = useTranslate();
  const {
    state: { prescriptions, mbpReferrerUri },
  } = useContext(AppContext);

  const addDrug = (
    selectedDrug: AutocompleteDrug | AutocompletePapDrug
  ): void => {
    props.onSelectDrug(selectedDrug as AutocompleteDrug);
  };

  return (
    <div className="AddPrescription">
      <DrugAutocomplete
        onSelectDrug={addDrug}
        submitButtonText={t("drug_search.add_drug")}
      />

      <div className="AddPrescription__actions">
        <Button
          onClick={(): void => {
            if (mbpReferrerUri !== "") {
              // standalone drugs, go back to my saved drugs
              props.goToViewPrescriptions();
            } else {
              sendDrugConfirmationTealiumEvent(prescriptions);
              props.goToPharmacySelection();
            }
          }}
          className="ds-c-button--primary e2e-drug-next ds-u-margin-right--0 ds-u-md-margin-right--2 mct-u-width--full mct-u-md-width--auto"
        >
          {t("prescription.button.done_adding_drugs")}
        </Button>
        {prescriptions.length === 0 && (
          <Button
            data-testid="continue-to-plans"
            className="mct-u-width--full mct-u-md-width--auto ds-u-margin-top--2 ds-u-md-margin-top--0"
            onClick={(): void => {
              // istanbul ignore next: tested elsewhere
              sendTealiumEvent("Find Plans - Add Drugs", "Continue to Plans");
              props.goToPlans();
            }}
          >
            {t("drug_search.continue_to_plans")}
          </Button>
        )}
      </div>
    </div>
  );
};

export default AddPrescription;
